import React from 'react';

import UploadFileIcon from '@mui/icons-material/UploadFile';

import { Button } from 'components/Button';

import { humanFileSize } from 'utils/formatters/file';

import { Wrapper, FileWrapper, FileName, FileSize, FileLink, FileSizeWrapper, FileNameWrapper } from './styles';

const CustomAttachmentDisplayValue = ({
  value,
  submissionTab = false,
}: {
  submissionTab?: boolean;
  value: { filename: string; size: number; url: string }[];
}): React.ReactElement => {
  const [showMore, setShowMore] = React.useState(false);

  return (
    <Wrapper>
      {value.slice(0, showMore ? value.length : 3).map(({ filename, size, url }) => (
        <FileWrapper key={filename} $submissionTab={submissionTab}>
          <FileNameWrapper $submissionTab={submissionTab}>
            <UploadFileIcon sx={{ color: '#757575' }} />
            <FileName>{filename}</FileName>
          </FileNameWrapper>
          {submissionTab ? (
            <FileSizeWrapper>
              <FileSize $submissionTab={submissionTab}>{humanFileSize(size)}</FileSize>
              <FileLink href={url} target="_blank" rel="noopener noreferrer" aria-label="Open in new tab">
                View file
              </FileLink>
            </FileSizeWrapper>
          ) : (
            <FileSize>{humanFileSize(size)}</FileSize>
          )}
        </FileWrapper>
      ))}
      {value.length > 3 && (
        <Button variant="text" style={{ alignSelf: 'flex-start' }} onClick={() => setShowMore(!showMore)}>
          {showMore ? 'Show less...' : 'Show more...'}
        </Button>
      )}
    </Wrapper>
  );
};

export default CustomAttachmentDisplayValue;
